import PositionPrize from './PositionPrize';
import Translation from '@/client/components/Translation';
import classNames from '@/external/classNames';
import Button from '@/external/components/Button';
import Modal from '@/external/components/Modal';
import ControlsClose from '@/external/icons/ControlsClose';
import getCdnImg from '@/shared/cdn/getCdnImg';
import Img from '@/shared/components/Img';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

type Props = {
  showDialog: boolean;
  loading: boolean;
  toggleDialog: () => void;
  handleAction: () => void;
  tournament?: TournamentFragment;
  translations: Record<string, string>;
};

const ClaimPrizeModal: FC<Props> = ({
  showDialog,
  toggleDialog,
  tournament,
  loading,
  handleAction,
  translations,
}) => (
  <Modal open={showDialog}>
    <Modal.Backdrop className="bg-black" onClose={toggleDialog} />
    <Modal.Panel className="max-w-xs bg-white p-6">
      <span
        className="absolute right-4 top-4 cursor-pointer"
        onClick={toggleDialog}
      >
        <ControlsClose className="text-moon-24" />
      </span>
      <div className={classNames('grid place-items-center gap-2')}>
        <Img
          src={getCdnImg('tournaments/icons/tournament-prize-won.svg')}
          height={80}
          width={80}
          alt={''}
        />
        <h2 className="text-moon-16 font-semibold text-bulma">
          <Translation
            translations={translations}
            id="general.congratulations"
          />
        </h2>
        <PositionPrize tournament={tournament} />
        <Button
          animation={loading ? 'progress' : undefined}
          disabled={loading}
          onClick={handleAction}
        >
          <Translation
            translations={translations}
            id="game-leaderboard.claim-prize"
          />
        </Button>
      </div>
    </Modal.Panel>
  </Modal>
);

export default ClaimPrizeModal;
